<template>
  <div :class="{fixed:isT}" style="width: 100%;bottom: 0;margin-top: 0.2rem; text-align: center;color: #fff;background: linear-gradient(99deg, rgba(6, 20, 111, 0.43) 0%, #0B209D 50%, rgba(6, 20, 111, 0.43) 100%);line-height: 45px;font-size: 16px">
    Copyright © 2022 <span style="margin-right: 20px;margin-left: 20px">主办单位：铜梁科学技术局</span> 技术支持：重庆易智网科技有公司
  </div>
</template>

<script>
export default {
  name: "web-footer",
  data () {
    return {
      isT:true
    };
  },
  mounted () {
    if(this.$route.name=='carrierTech'){
       this.isT=false
    }

  },
}
</script>

<style scoped>
.fixed{
  position: fixed;
}
</style>